const values = [
  { icon: "ri-organization-chart", title: "分类清晰", desc: "四大栏目 + 细颗粒标签，让信息各归其位，不用在信息流里反复滑动。" },
  { icon: "ri-scales-3-line", title: "观点平衡", desc: "涉及争议话题时并列呈现多方声音，还原事实与上下文，不做单一声量放大。" },
  { icon: "ri-file-search-line", title: "有据可循", desc: "事件梳理标明关键时间节点与信源线索，方便你进一步自行查证。" },
  { icon: "ri-refund-2-line", title: "允许纠错", desc: "信息可能滞后或有疏漏，欢迎随时反馈，核实后我们会第一时间更正。" },
];

export default function ValueBand() {
  return (
    <section className="relative w-full overflow-hidden bg-primary-500 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-semibold text-background-50">
              <i className="ri-compass-3-line"></i>我们在坚持什么
            </span>
            <h2 className="mt-4 font-heading text-2xl leading-snug font-black text-background-50 md:text-3xl">
              让浏览回归「清楚」与「高效」
            </h2>
            <p className="mt-3 max-w-md text-sm leading-6 text-primary-100 md:text-base">
              信息爆炸时代，我们想做的不是再添一份噪音，而是当一个耐心的整理者，帮你把值得看的内容轻轻放好。
            </p>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-50/15 bg-background-50/10 p-5 backdrop-blur">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-lg text-primary-600">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-background-50">{v.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-primary-100">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}